<template>
  <XModal
    :is-open="showModal"
    data-testid="copyLinkFormModal"
    @close="$emit('close')"
  >
    <template #header>
      {{ $t('flowModule.modalCopyLink.title') }}
    </template>
    <template #default>
      <p>
        {{ $t('flowModule.modalCopyLink.description') }}
      </p>
      <div :class="$style.inputContainer">
        <BaseCopyInput
          :class="$style.formFlowLink"
          :value="formFlowLink"
          :button-text="false"
          button-icon="link"
        />
        <!--
          FLOW_FORM_WHATSAPP_REQUEST
          TODO: remove feature frag and keep inner code
        -->
        <FeatureFlag name="flowFormWhatsappRequest">
          <XButton
            size="sm"
            border-radius="circle"
            :color="WHATSAPP_COLOR"
            :class="$style.button"
            data-testid="flowFormWhatsappRequestLink"
            @click="
              $emit('open-modal', FORM_FLOW_MODAL_CONSTANTS.formFlowWhatsappSendModal, selectedFlow)
            "
          >
            <XIcon
              icon="whatsapp"
              icon-style="fab"
            />
          </XButton>
        </FeatureFlag>
      </div>
      <XLink
        :to="formFlowLink"
        target="_blank"
        data-testid="formFlowLink"
      >
        {{ $t('flowModule.modalCopyLink.link') }}
      </XLink>
    </template>
    <template #actions>
      <XButton
        data-testid="modalCloseButton"
        @click="$emit('close')"
      >
        {{ $t('general.action.close') }}
      </XButton>
    </template>
  </XModal>
</template>

<script>
import { useStore } from '@/store';
import { defineComponent, computed } from 'vue';
import BaseCopyInput from '@base/components/BaseCopyInput/BaseCopyInput.vue';
import { FORM_FLOW_MODAL_CONSTANTS } from '@flow/constants';

export default defineComponent({
  name: 'FormFlowCopyLinkModal',
  components: {
    BaseCopyInput,
  },
  props: {
    flow: {
      type: Object,
      default: () => {},
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const WHATSAPP_COLOR = '#40C351';
    const store = useStore();

    const selectedFlow = computed(() => store.getters['formFlow/getSelectedFlow']);
    const formFlowLink = computed(() => selectedFlow.value?.links?.fluxia || '');

    return {
      formFlowLink,
      selectedFlow,
      FORM_FLOW_MODAL_CONSTANTS,
      WHATSAPP_COLOR,
    };
  },
});
</script>

<style lang="scss" module>
.formFlowLink {
  margin-bottom: var(--space-regular);
}

.inputContainer {
  display: flex;
  gap: var(--space-small-xx);
}

.button {
  flex-shrink: 0;
}
</style>
